// removed by extract-text-webpack-plugin
module.exports = {"content":"JjTyqszu1QgRxxjrkbx","pointer":"_2eXgQN9qHrWIianMbr_DpH","title":"_3LWm6C1LMtaVerb5Y22z2B","contentBlack":"_1hx_klDi8CVKPSEOizL8oX"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Timeline/Containers/BoxArticle/style.css
// module id = 684
// module chunks = 38